import React from 'react';
import { TextInput, Button } from 'carbon-components-react';
import { FormError } from 'components';
import { ArrowRight16 } from '@carbon/icons-react';
import { connect } from 'react-redux';
import { CFCProps } from 'types';
import { RootState } from 'redux/root.reducer';

const RegistrationForm: React.FC<Props | any> = (props: any) => {
  const isLoading =
    props.reg?.submitting || props.login?.submitting || props.app?.loading;

  const {
    values,
    touched: fTouched,
    errors: fErrors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting
  } = props;
  const inputError = ((errors: any, touched: any) => (
    key: 'username' | 'firstname' | 'lastname' | 'password' | 'confirmPassword'
  ) => errors[key] && touched[key] && <FormError>{errors[key]}</FormError>)(
    fErrors,
    fTouched
  );

  return (
    <form onSubmit={handleSubmit}>
      <section className="reg-form-item">
        <TextInput
          id="firstname"
          name="firstname"
          labelText="First Name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.firstname}
          data-testid="firstname"
        />
        {inputError('firstname')}
      </section>
      <section className="reg-form-item">
        <TextInput
          id="lastname"
          name="lastname"
          labelText="Last Name"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.lastname}
          data-testid="lastname"
        />
        {inputError('lastname')}
      </section>
      <section className="reg-form-item">
        <TextInput
          id="username"
          name="username"
          labelText="Email Address"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.username}
          data-testid="username"
        />
        {inputError('username')}
      </section>
      <section className="reg-form-item">
        <TextInput.PasswordInput
          id="password"
          name="password"
          labelText="Password"
          tooltipAlignment="end"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.password}
          data-testid="password"
        />
        {inputError('password')}
      </section>
      <section className="reg-form-item">
        <TextInput.PasswordInput
          id="confirmPassword"
          name="confirmPassword"
          labelText="Confirm Password"
          tooltipAlignment="end"
          onChange={handleChange}
          onBlur={handleBlur}
          value={values.confirmPassword}
          data-testid="confirmPassword"
        />
        {inputError('confirmPassword')}
      </section>
      <section className="reg-form-item">
        <Button
          className="reg-submit"
          type="submit"
          kind={!fErrors ? 'danger' : 'primary'}
          renderIcon={ArrowRight16}
          data-testid="submit"
          disabled={isLoading || isSubmitting}
        >
          {isLoading || isSubmitting ? 'Submitting...' : 'Registration'}
        </Button>
      </section>
    </form>
  );
};

const mapStateToProps = ({ reg, login, app }: RootState) => ({
  reg,
  login,
  app
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

RegistrationForm.displayName = 'RegistrationForm';

export default connector(RegistrationForm);
